import { Controller } from "@hotwired/stimulus"
import GreenAudioPlayer from "../audio-green.cjs"

// Connects to data-controller="player"
export default class extends Controller {
  static values = {
    voicePresent: Boolean
  }

  connect() {
    this.player = new GreenAudioPlayer('.player');
    document.querySelector('audio').setAttribute('src', document.querySelector('input[name="voice_type"]:checked').value);
  }

  stop() {
    if (!this.player.player.paused) {
      document.querySelector('.play-pause-btn').click();
    }
  }

  toggleVoice(event) {
    this.stop();

    if (!this.voicePresentValue && document.querySelector('#my-voice').checked) {
      Turbo.visit('/voice/start')
    }

    document.querySelector('audio').setAttribute('src', event.target.value);
  }
}
